import React from "react";
import styled from "styled-components";

const AboutContainer = styled.div`
  background: linear-gradient(to right, #536976, #292e49);
  padding: 80px 0;
`;

const AboutContent = styled.div`
  display: flex;
  flex-direction: column-reverse;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const AboutText = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 30px;

  h3 {
    font-size: 30px;
    color: #fff;
    margin-bottom: 12px;
    font-weight: 700;
  }

  h1 {
    font-size: 40px;
    color: #fff;
    font-weight: 700;
    line-height: 40px;
    margin-bottom: 15px;
  }

  p {
    font-size: 22px;
    color: #fff;
    font-weight: 300;
    padding-top: 10px;
  }

  @media (min-width: 768px) {
    width: 50%;
    text-align: initial;
    margin-bottom: 0;
  }
`;

const AboutImage = styled.div`
  width: 100%;
  text-align: center;

  img {
    width: 100%;
    max-height: 400px;
    object-fit: cover;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }

  @media (min-width: 768px) {
    width: 50%;
    text-align: initial;
    margin-bottom: 0;
  }
`;

const About = () => {
  return (
    <AboutContainer>
      <div className="container">
        <div className="row">
          <AboutContent>
            <AboutText>
              <h3>About Us</h3>
              <h1>RAZQACAKE</h1>
              <p>
                Kami bangga dapat menjadi bagian dari momen-momen penting dalam hidup pelanggan kami.
                Setiap kue yang kami buat adalah hasil dari cinta dan dedikasi kami untuk membawa kebahagiaan
                kepada Anda dan orang-orang terkasih Anda. Kepuasan pelanggan adalah prioritas kami,
                dan kami berkomitmen untuk memberikan pelayanan yang ramah, responsif, dan Prosen pemesanan melalui whatsapp kami
              </p>
            </AboutText>
            <AboutImage>
              <div className="about__img">
                <img src="/img/pizza.jpg" alt="Pizza" />
              </div>
            </AboutImage>
          </AboutContent>
        </div>
      </div>
    </AboutContainer>
  );
};

export default About;
